<template>
  <FormSelect
    :value="value"
    @input="updateValue"
    :optionsPromise="taskTypePromise"
    :field="field"
    :placeholder="placeholder"
    :note="note"
  />
</template>



<script>
import _ from 'lodash'

export default {
  name: 'TaskTypeSelect',
  model: {
    event: 'update'
  },
  props: {
    value: [Number, String],
    field: String,
    placeholder: String,
    note: String,
    allowNone: Boolean,
    noneLabel: {
      type: String,
      default: 'None'
    },
    activeOnly: {
      type: Boolean,
      default: true
    },
    despatchEnabledOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      taskTypePromise: this.getTaskTypePromise(),
    }
  },
  methods: {
    getTaskTypePromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.tasksService.getTaskTypeList()
        .then(response => {
          let typeList = response.data

          if(this.activeOnly)
            typeList = typeList.filter(taskType => taskType.isActive)
          if(this.despatchEnabledOnly)
            typeList = typeList.filter(taskType => taskType.isDespatchEnabled)

          var taskTypeOptions = typeList.map(taskType => {
            return { name: `${taskType.name}`, value: taskType.id }
          })

          return resolve(_.concat(_.compact(this.allowNone ? [{ value: null, name: this.noneLabel }] : null), taskTypeOptions))
        })
        .catch(err => { return reject(err) })
      })
    },
    updateValue(value) {
      this.$emit('update', value ? parseInt(value) : null)
    }

  }
}
</script>